<div class="tw-text-center tw-font-extrabold tw-text-white tw-text-xl md:tw-text-3xl tw-pb-6">Our Partners</div>
<div class="container tw-grid tw-grid-cols-3 md:tw-grid-cols-5 lg:tw-grid-cols-7 tw-gap-4 md:tw-gap-6 ">
  <div *ngFor="let image of partnerImages">
    <img src="/assets/images/corporate/brand-partners/{{image.icon}}" class="tw-w-full tw-rounded" alt="{{image.brand}}">
  </div>
</div>